/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

interface INavbarScope extends ng.IScope {
    showBreadcrumbs: boolean
    isEmployeeView: boolean
    crumbs: any
    image: string
    employeeFilters: string
    toggleSidebarOrBack: any
    logout: any
    openEmployeeFilter: any
    cleanFilters: any
    myProfile: any
    hasPermission: any
    org: any
    all_offices: Array<any>
    all_divisions: Array<any>
    all_departments: Array<any>
    offices: Array<any>
    divisions: Array<any>
    departments: Array<any>
    set_office: (string) => void
    set_division: (string) => void
    set_department: (string) => void
    current_office: string
    current_division: string
    current_department: string
}

class NavbarDirective {
    public scope = true;
    public restrict = 'A';
    public hasPermission;

    constructor(private $state: ng.ui.IStateService,
                private $rootScope: ng.IRootScopeService,
                private Login: ILoginService,
                private User: IUserService,
                private $uibModal: any,
                private Employee: IEmpService,
                private Org: IOrgsService) {

                
            
    }

    public link = (scope: any) => {
       
        scope.hasPermission = this.User.hasPermission;

        scope.showBreadcrumbs = true;
        scope.isAdminHomeView = true;
        scope.crumbs = [];
        scope.image = "/static/images/placeholder-nobody2.png";

        scope.isAdmin = this.User.getCurrentUser().userData.user.is_superuser;
        scope.not_insurance_only_client = !this.User.getCurrentUser().isInsuranceOnlyClient;
        scope.isHrm = this.User.getCurrentUser().isHRM;

        this.makeCrumbs(scope);
        this.checkHelp();

        this.$rootScope.$on('$stateChangeSuccess', () => {
            this.makeCrumbs(scope);
        });

        this.$rootScope.$on("profilePicChanged", (event, args) => {
            scope.image = args.imageUrl;
        });


        scope.isEmployeeView = (this.$state.current.url === '/employees') ? true : false;
        scope.$on('$stateChangeStart', (e: any, toState: any) => {
            if (toState.url === '/employees') {
                if (!this.User.getCurrentUser().userData.user.is_superuser) {
                    this.Org.getOrgFromCache((org) => {
                        scope.org = org;
                        if (!org.extra.offices) {
                            org.extra.offices = [];
                        }
                        scope.all_offices = scope.offices =  org.extra.offices
                        scope.all_divisions = scope.divisions = [].concat.apply([],
                            org.extra.offices.map((o) => {
                                if (o.divisions) {
                                    o.divisions.map((d) => {
                                        // d.display_name = o.name + ': ' + d.name
                                    })
                                    return o.divisions
                                } else {
                                    return []
                                }
                            }))
                        scope.all_departments = scope.departments = [].concat.apply([],
                            org.extra.offices.map((o) => [].concat.apply([],
                                o.divisions ? o.divisions.map((d) => d.departments || []) : [])))
                        scope.isEmployeeView = true;
                    })

                }

            } else {
                scope.isEmployeeView = false;
            }
            if (toState.url === '/admin/orgs') {
                scope.isAdminHomeView = true;
            } else {
                scope.isAdminHomeView = false;
            }

        });

        scope.toggleSidebarOrBack = () => {
            if (scope.showBreadcrumbs) {
                this.$state.go('^');
            } else {
                $('body').toggleClass('mini-leftbar');
                $('body').scrollTop(0);
            }
        };

        scope.logout = () => {
            this.$rootScope.$emit('$EL', 'logout');
            this.Login.logout().$promise.then(() => {
                //cleaning user-id attr
                angular.element('body').removeAttr('user-id')
                this.User.clearUser();
                localStorage.removeItem('orgName');
                this.$state.go('login');
            });
        };



        scope.openEmployeeFilter = () => {
            let modalInstance: any = this.$uibModal.open({
                controller: 'EmployeeFilterController as C',
                templateUrl: '/static/templates/modals/filterModal.html'
            });
        };

        scope.cleanFilters = () => {
            this.Employee.cleanFilters();
            scope.divisions = scope.all_divisions
        }

        scope.myProfile = () => {
            this.$rootScope.$emit('$EL', 'employee.profile.me');
            this.$state.go('root.employees.details', { id: this.User.getUserId() });
        }

        scope.set_office = (office) => {
            scope.current_office = office
            if (office) {
                office.divisions = office.divisions || []
                scope.divisions = office.divisions
                scope.departments = [].concat.apply([],
                office.divisions.map((d) => d.departments || []))

            } else {
                scope.divisions = scope.all_divisions
                scope.departments = scope.all_departments
            }

            this.$state.go('root.employees');
            var filters = angular.copy(this.Employee.getFilters())
            filters.office = this.mk_obj(office)
            filters.division = undefined
            filters.department = undefined
            this.Employee.setFilters(filters)
        }

        scope.set_division = (division) => {
            scope.current_division = division

            if (division) {
                scope.current_office = scope.all_offices.filter((o) =>
                    o.divisions ? o.divisions.filter((d) => d.name == division.name).length : 0
                )[0]
                scope.departments = division.departments
            } else {
                scope.set_office(scope.current_office)
            }

            this.$state.go('root.employees');
            var filters = angular.copy(this.Employee.getFilters())
            filters.office = this.mk_obj(scope.current_office)
            filters.division = this.mk_obj(division)
            filters.department = undefined
            this.Employee.setFilters(filters)
        }

        scope.set_department = (department) => {
            scope.current_department = department
            if (department) {
                scope.current_division = scope.all_divisions.filter((d) =>
                    d.departments ? d.departments.filter((d) => d.name == department.name).length : 0
                )[0]
                scope.current_office = scope.all_offices.filter((o) =>
                    o.divisions ? o.divisions.filter((d) => d.name == scope.current_division.name).length : 0)[0]
            }



            this.$state.go('root.employees');
            var filters = angular.copy(this.Employee.getFilters())
            filters.office = this.mk_obj(scope.current_office)
            filters.division = this.mk_obj(scope.current_division)
            filters.department = this.mk_obj(department)
            this.Employee.setFilters(filters)
        }

        scope.showHelp = () => {
            let value = JSON.parse(localStorage.getItem('chatIcon')).isVisible;
            if(value == 'false'){
                // document.getElementById("livechat-compact-container").style.display = "block";
                // document.getElementById("chat-widget-container").style.display = "block";
                window.LiveChatWidget.call('maximize');

                document.getElementById("xBtn").style.display = "block";
                document.getElementById("help").style.display = "none";
                let iconVisible = {
                   isVisible : 'true'
                 }
                localStorage.setItem('chatIcon',  JSON.stringify(iconVisible));
            }
        }



        scope.getFilters = () => {
            let filters = this.Employee.filters
            var firstFilter = true
            var filterText  = ''
            var finalText   = undefined

            for (var filter in filters) {
                if (typeof filters[filter] === 'undefined')
                  continue
                if(typeof filters[filter] === 'object') {
                    filterText = ''
                    let l_filter = filters[filter]
                        let first = true
                        for (var prop in l_filter) {
                            // Make sure that this is not inherited properties
                            if (l_filter.hasOwnProperty(prop)) {
                                if (l_filter[prop]) {
                                    if (first) {
                                        first=false
                                    } else {
                                        filterText += ', '
                                    }
                                    filterText += prop
                                }
                            }
                        }
                    //filterText = Object.keys(filters[filter]).join(', ')
                }
                else
                    filterText = filters[filter]

                if(firstFilter)
                    finalText = filterText
                else
                    finalText += ', ' + filterText
                firstFilter = false
            }

            if (finalText != undefined && finalText.length > 30)
                finalText = finalText.substring(0, 29) + "..."

            if (finalText != undefined)
                scope.employeeFilters = finalText.charAt(0).toUpperCase() + finalText.slice(1);
            else
                scope.employeeFilters = finalText

            return this.Employee.filters
        }


        this.getThumbnail(scope);
    };

    private mk_obj(item: any): any {
        let obj = {}
        if (item) {
            obj[item.name] = true
        }

        return obj
    }

    private makeCrumbs(scope: any): void {
        scope.showBreadcrumbs = (this.$state.current.data && this.$state.current.data.showBreadcrumbs);
        scope.crumbs = this.buildBreadCrumbs();
    }


    private checkHelp(){
        
        let value = JSON.parse(localStorage.getItem('chatIcon')).isVisible;
        if(value == 'false'){
            document.getElementById("help").style.display = "inline-block";
            } else {
            document.getElementById("help").style.display = "none";
            }
    }

    private getThumbnail(scope: any) : void {
        if (this.User.getCurrentUser().userData.id) {
            this.Employee.loadEmployee(this.User.getCurrentUser().userData.id).then((response: IEmpResponse) => {
                //thumbnail.jpg is generated by aws S3
               scope.image = response.extra.image && response.extra.image !== '/static/images/placeholder-nobody2.png' ? response.extra.image +".thumbnail.jpg" : '/static/images/placeholder-nobody2.png'
            })
        }
    }

    private buildBreadCrumbs(): any {
        let crumbs: any = [];
        let root: boolean = false;
        let st: any = this.$state.$current;

        if (st.self.data && st.self.data.displayName) {
            crumbs.unshift( { name: st.self.data.displayName, route: st.self.name });
            let breaker: number = 0;
            while (!root && breaker < 10) {
                if (st.parent.self.data && st.parent.self.data.displayName) {
                    crumbs.unshift({ name: st.parent.self.data.displayName, route: st.parent.self.name });
                    st = st.parent;
                }
                root = (st.parent.self.name === 'root');
                breaker++;
            }
        }
        return crumbs;
        
    }


    public static DirectiveFn($state: ng.ui.IStateService,
                              $rootScope: ng.IRootScopeService,
                              Login: any,
                              User: IUserService,
                              $uibModal: any,
                              Employee: IEmpService,
                              Org: IOrgsService): NavbarDirective {
        return new NavbarDirective($state, $rootScope, Login, User, $uibModal, Employee, Org);
    }
}

NavbarDirective.DirectiveFn.$inject = ['$state', '$rootScope', 'Login', 'User', '$uibModal', 'Employee', 'Orgs'];

angular.module('beneple.global').directive('navbar', NavbarDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/navbar.directive.ts